import type { CmmdProject } from "@cmmd-forge/contracts";

/** Canonical archived project identities used by ordinary Forge project pickers. */
export function selectArchivedCmmdProjectIds(
  projects: readonly CmmdProject[],
): ReadonlySet<number> {
  return new Set(
    projects.flatMap((project) => (project.status === "archived" ? [Number(project.id)] : [])),
  );
}
